import { connect } from 'react-redux';
import { compose } from 'redux';
import { createBypassedUpgrade as createUpgradePurchase } from '../actions';
import { updatePlan } from 'subscriptions/bypassed/actions';
import { getBypassedUpgradePurchase } from 'reducers';
import subscriptionDecorator from 'subscriptions/decorator';
import UpgradePurchase from './UpgradePurchase';

const mapStateToProps = (state, { subId }) => ({
  purchase: getBypassedUpgradePurchase(state, subId)
});

const mapDispatchToProps = {
  createUpgradePurchase,
  updatePlan,
}

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(UpgradePurchase);
